export const GET_DASHBOARD_REPORT = "GET_DASHBOARD_REPORT";
export const GET_DASHBOARD_CHART_REPORT = "GET_DASHBOARD_CHART_REPORT";
